import React from 'react';
import { Key } from 'lucide-react';

const ApiTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100 mb-4">
          API Keys
        </h3>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
          Manage your API keys for programmatic access to DNS Fabric
        </p>

        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 mb-6">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                API Key Management
              </h3>
              <div className="mt-2 text-sm text-yellow-700 dark:text-yellow-300">
                API key generation and management will be implemented in a future update.
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="border border-slate-200 dark:border-slate-600 rounded-lg p-4">
            <div className="flex justify-between items-center">
              <div>
                <h4 className="font-medium text-slate-900 dark:text-slate-100">
                  Default API Key
                </h4>
                <p className="text-sm text-slate-500 dark:text-slate-400">
                  Created on {new Date().toLocaleDateString()}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <span className="px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 text-xs rounded-full">
                  Active
                </span>
                <button className="text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 text-sm">
                  Revoke
                </button>
              </div>
            </div>
            <div className="mt-3">
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  value="dns_fabric_••••••••••••••••"
                  disabled
                  className="flex-1 px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-slate-500 dark:text-slate-400 font-mono text-sm"
                />
                <button className="px-3 py-2 text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 text-sm border border-blue-600 dark:border-blue-400 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20">
                  Show
                </button>
              </div>
            </div>
          </div>
        </div>

        <button className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Key className="w-4 h-4 mr-2" />
          Generate New Key
        </button>
      </div>
    </div>
  );
};

export default ApiTab;